<template>
  <AuthLayout :current-step="currentStep" many-steps>
    <Register v-model="currentStep" />
  </AuthLayout>
</template>

<script>
  import AuthLayout from '../layouts/Auth';
  import Register from '../containers/auth/Register';

  export default {
    meta: {
      title: 'Registration',
    },
    components: { AuthLayout, Register },
    data() {
      return {
        currentStep: 1,
      };
    },
    created() {
      if (this.$route.query?.step) {
        this.currentStep = this.$route.query?.step;
      }
    },
  };
</script>
